import * as types from "./mutation-types";

export const mutations = {
    [types.CREATE_CATEGORIES](state, payload) {
        state.categories = payload;
    }
}